import { SaasEnv } from '@caju-beneficios/sponsor-v2-lib'
import { Route, Switch } from 'react-router-dom'
import { CardsPage } from './cards'
import { CompanyPanelPage } from './companyPanel'
import { ConfigsPage } from './configs'
import { EmployeesPage } from './employees'
import { HomePage } from './home'

export interface PrivateRoutesProps {
  children?: any
}

export function PrivateRoutes(props: PrivateRoutesProps) {

  return (
    <SaasEnv onNavigate={(info) => window.location.assign(info)}>
      <div style={{padding: 16}}>
        <Switch>
          <Route path={'/'} exact component={HomePage} />
          <Route path={'/employees'} component={EmployeesPage} />
          <Route path={'/cards'} component={CardsPage} />
          <Route path={'/configs'} component={ConfigsPage} />
          <Route path={'/companyPanel'} component={CompanyPanelPage} />
        </Switch>
      </div>
    </SaasEnv>
  )
}
